import h from 'virtual-dom/h';
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {HistoryMessage} from "../../../../types/history";
import {VChild} from "virtual-dom";
import LiveChatState from "../livechat-state";
import {HistoryMessageLiveChatConnectBanner} from "../models/HistoryMessages";


export default class ConnectBanner
{
    
    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _stateManager: LiveChatState;
    
    
    //#region Public Interface
    
    constructor(settings: DefaultSettings, stateManager: LiveChatState)
    {
        this._settings = settings;
        this._stateManager = stateManager;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    getReducer()
    {
        return (state = defaultState): AlmeState => state;
    }

    doesRender(message: HistoryMessage): boolean
    {
        return message.type === this._settings.messageConstants.livechatConnectBanner;
    }

    getRenderer()
    {
        return (message: HistoryMessage): VChild =>
        {
            if (!this.doesRender(message)) { return []; }

            const operatorDataIndex = (message as HistoryMessageLiveChatConnectBanner).operatorDataIndex;

            return h('span', [this.createConnectBanner(operatorDataIndex)]);
        };
    }

    //#endregion



    //#region Render Methods

    createConnectBanner(operatorDataIndex: number): VChild
    {
        const { 
            chatBannerConnectPrimary,
            chatBannerConnectSecondary,
            chatBannerConnectAdditional,
            chatBannerConnectContainer,
        } = this._settings.classNames.livechat;

        const { 
            chatBannerConnectedPrimary,
            chatBannerConnectedSecondary,
            chatBannerConnectedAdditional, 
        } = this._settings.livechat.textConstants;

        const operatorName = this._stateManager.getOperatorData(operatorDataIndex)?.Name ?? this._settings.livechat.defaultOperatorName;
        const secondaryText = chatBannerConnectedSecondary.replace(/{0\}/g, operatorName);

        const primaryBanner = h('div', { className: chatBannerConnectPrimary }, chatBannerConnectedPrimary);
        const secondaryBanner = h('div', { className: chatBannerConnectSecondary }, secondaryText);
        const additionalBanner = h('div', { className: chatBannerConnectAdditional }, chatBannerConnectedAdditional);

        return h('div', { className: chatBannerConnectContainer }, [primaryBanner, secondaryBanner, additionalBanner]);
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/renderers/connect-banner.ts